const bookmarkStorageName = "bookmarks";

document.addEventListener("DOMContentLoaded", (event) => {
	updateView();
	for (const node of event.target.querySelectorAll(".bookmark-button")) {
		for (const button of node.querySelectorAll("button")) {
			button.addEventListener("click", () => onBookmarkButtonClick(node));
		}
	}
	fetchBookmarks();
});

function onBookmarkButtonClick(node) {
	const bookmarkId = Number(node.dataset.page ?? '');
	getBookmarks().includes(bookmarkId) ? removeBookmark(bookmarkId) : addBookmark(bookmarkId);
}

function addBookmark(id) {
	if (!getBookmarks().includes(id)) {
		const newBookmarks = [...getBookmarks(), id];
		localStorage.setItem(bookmarkStorageName, JSON.stringify(newBookmarks));
	}
	updateView();
}

function removeBookmark(id) {
	const newBookmarks = getBookmarks().filter(bookmarkedId => bookmarkedId !== id);
	localStorage.setItem(bookmarkStorageName, JSON.stringify(newBookmarks));
	updateView();
}

function updateView() {
	for (const node of document.querySelectorAll(".bookmarkCounter__count")) {
		node.textContent = getBookmarks().length;
	}

	for (const node of document.querySelectorAll(".bookmark-button")) {
		const bookmarkId = Number(node.dataset.page ?? '');
		getBookmarks().includes(bookmarkId) ? node.classList.add("bookmark-button--active") : node.classList.remove("bookmark-button--active");
	}
}

function getBookmarks() {
	return JSON.parse(localStorage.getItem(bookmarkStorageName) ?? "[]");
}

async function fetchBookmarks() {
	const response = await fetch(`/bookmarks.json?pages=${getBookmarks().join(",")}`);
	const fetchedBookmarks = await response.json();
	for (const bookmarkList of document.querySelectorAll("ul.bookmark-list")) {
		bookmarkList.childNodes.forEach(c => c.remove());
		for (const bookmark of fetchedBookmarks) {
			const newListElement = document.createElement("li");

			const newAnchorElement = document.createElement("a");
			newAnchorElement.setAttribute("href", bookmark.slug);

			const newTitleElement = document.createElement("span");
			newTitleElement.textContent = bookmark.title;
			newTitleElement.classList.add("bookmark-list__linktext")

			const newImageWrapperElement = document.createElement("span");
			newImageWrapperElement.classList.add("bookmark-list__image-wrapper");

			for (const mediaItem of bookmark.media) {
				const newImageElement = document.createElement("img");
				newImageElement.setAttribute('src', mediaItem.url ? mediaItem.url : bookmarkList.dataset.imagePlaceholder);
				newImageWrapperElement.append(newImageElement);
			}

			newAnchorElement.append(newTitleElement, newImageWrapperElement);
			newListElement.append(newAnchorElement);
			bookmarkList.append(newListElement);
		}
	}
}
